import { Skeleton, Typography } from "djuno-design";
import BucketIcon from "./../../../../assets/icons/bucket.svg?react";

const BucketsCountWidget: React.FunctionComponent<{
  bucketCount?: number;
  loading?: boolean;
}> = ({ bucketCount, loading }) => {
  return (
    <div className="w-full rounded-lg border dark:border-dark-2 bg-white dark:bg-dark-3 p-5">
      <div className="flex flex-col w-full gap-3">
        <div className="flex justify-between items-center">
          <Typography.Text className="!text-xs md:!text-sm">
            Buckets
          </Typography.Text>
          <BucketIcon className="w-5 dark:text-slate-50" />
        </div>
        <div className="h-10 flex items-end gap-1">
          {loading && <Skeleton />}
          {!loading && (
            <Typography.Title level={2} className="!mb-0">
              {bucketCount}
            </Typography.Title>
          )}
        </div>
      </div>
    </div>
  );
};
export default BucketsCountWidget;
